import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class CustomerApiService {
    constructor(private http: HttpClient) { }

    getAllCustomer(request: any) {
        return this.http.put(
            environment.baseUrl + `ecommerce/customer360/filter`, request
        )
    }

    getCustomerTimeline(customerId: string) {
        return this.http.get(environment.baseUrl + `ecommerce/customer-timeline/${customerId}`);
    }

    getTransactionData(request: any) {
        return this.http.put(
            environment.baseUrl + `ecommerce/customer360/transactions`, request
        );
    }

    assignStafftoCustomer(customerId: string, request: any) {
        return this.http.put(
            environment.baseUrl + `ecommerce/customer360/${customerId}/assign-staff`, request
        )
    }


    getOverviewData(customerId: string) {
        return this.http.get(
            environment.baseUrl + `ecommerce/customer360/${customerId}/overview`
        )
    }

    getUserAnalyticsDashboard(userId: string, isJewelery: boolean) {
        let businessId = localStorage.getItem('businessId');
        return this.http.get(
            environment.baseUrl + `ecommerce/analytics/dashboard/${userId}?businessId=${businessId}&isJewelery=${isJewelery}`
        )
    }

    getPassbookSchemes(customerId: string) {
        return this.http.get(
            environment.baseUrl + `ecommerce/customer360/${customerId}/passbook-schemes?businessId=${localStorage.getItem('businessId')}`
        )
    }

    getExcelFields(formData: FormData) {
        return this.http.post(
            environment.baseUrl + ``, formData
        )
    }

    uploadExcel(formData: FormData) {
        return this.http.post(
            environment.baseUrl + `ecommerce/user/customer360/create-invoice?businessId=${localStorage.getItem('businessId')}`, formData
        )
    }

}
